<script setup lang="ts">
import { onUnmounted, reactive } from "vue";
import { clearObject } from "@zyzgroup/core-common";

// for merge ce shadow-root styles
defineOptions({
  customOptions: {},
  inheritAttrs: true
});

const props = withDefaults(
  defineProps<{
    type?: "flex" | "grid" | "transform" | "table";
  }>(),
  {
    type: "grid"
  }
);

const emits = defineEmits<{
  // (event: "click"): void;
}>();

const parentStyle = reactive<Record<string, string>>({});
const childStyle = reactive<Record<string, string>>({});

function setStyle() {
  clearObject(parentStyle);
  clearObject(childStyle);
  switch (props.type) {
    case "table":
      parentStyle.display = "table";
      childStyle.display = "table-cell";
      childStyle.verticalAlign = "middle";
      childStyle.textAlign = "center";
      break;
    case "transform":
      childStyle.position = "absolute";
      childStyle.top = "50%";
      childStyle.left = "50%";
      childStyle.transform = "translate(-50%, -50%)";
      break;
    case "grid":
      parentStyle.display = "grid";
      parentStyle.justifyContent = "center";
      parentStyle.alignItems = "center";
      break;
    case "flex":
    default:
      parentStyle.display = "flex";
      childStyle.margin = "auto";
  }
}
setStyle();

onUnmounted(() => {});

defineExpose({});
</script>

<template>
  <div
    class="layout-center"
    style="
      position: relative;
      display: block;
      width: 100%;
      height: 100%;
      overflow: hidden;
    "
    :style="parentStyle"
  >
    <div :style="childStyle">
      <slot></slot>
    </div>
  </div>
</template>
